/**
 * @author      david.loehr@zumper.com (David Loehr)
 * @copyright   Copyright (c) 2020, Zumper
 * @description FooterInnerContainer component
 */

import { selectNow } from '@zcode-ui/web-zumper-global-state'
import { LinkOrButton } from '@zcode-ui/web-zumper-ui'
import { App, FooterWithTracking, type FooterWithTrackingProps } from '@zcode-ui/zumper-footer'
import React from 'react'
import { useSelector } from 'react-redux'

export type FooterInnerContainerProps = Omit<FooterWithTrackingProps, 'app'>

export const FooterInnerContainer = (forwardProps: FooterInnerContainerProps) => {
  return (
    <FooterWithTracking
      {...forwardProps}
      app={App.NZR}
      LinkOrButton={LinkOrButton}
      now={useSelector(selectNow)}
    />
  )
}
